import type { Player, Round, Standing } from "../types";
import { getStandings } from "../data";
import { Card, Table } from "react-bootstrap";

interface StandingsTableProps {
  rounds: Round[];
  players: Player[];
  title: string;
  advancementCount: number;
}

/** Renders a standings table sorted by wins, Buchholz, then game diff. */
export default function StandingsTable({
  rounds,
  players,
  title,
  advancementCount,
}: StandingsTableProps) {
  const standings: Standing[] = getStandings(rounds, players);

  const initialRound: boolean = rounds.length < 1;

  return (
    <Card>
      <Card.Header className="fw-semibold">{title}</Card.Header>
      <Table size="sm" className="mb-0 standings-table standings-table--mono">
        <thead>
          <tr className="small text-muted">
            <th className="ps-3">#</th>
            <th>Player</th>
            {initialRound ? null : (
              <>
                <th className="text-center">W</th>
                <th className="text-center">L</th>
                <th
                  className="text-center"
                  title="Buchholz: sum of opponents' wins"
                >
                  Buch
                </th>
                <th className="text-center pe-3" title="Game differential">
                  +/-
                </th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {standings.map((standing: Standing, i: number) => {
            const advancing = i < advancementCount;
            return (
              <tr
                className={advancing ? "standings-flag" : ""}
                key={standing.id}
              >
                <td className="ps-3 text-muted">
                  {i + 1}
                  {advancing && (
                    <span className="standings-flag__tag">ADV</span>
                  )}
                </td>
                <td className="fw-medium">{standing.name}</td>

                {initialRound ? null : (
                  <>
                    <td className="text-center">{standing.wins}</td>
                    <td className="text-center text-muted">
                      {standing.losses}
                    </td>
                    <td className="text-center text-muted">
                      {standing.buchholzScore}
                    </td>
                    <td className="text-center text-muted pe-3">
                      {standing.gameDiff > 0 ? `+${standing.gameDiff}` : standing.gameDiff}
                    </td>
                  </>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
}
